import { NgModule } from '@angular/core'
import { TransactionDetailsModalComponent } from './components/transaction-details-modal/transaction-details-modal.component'
import { StatusBadgeComponent } from './components/status-badge/status-badge.component'
import { TransactionOverviewComponent } from './components/transaction-overview/transaction-overview.component'
import { AuthorizationDetailsComponent } from './components/authorization-details/authorization-details.component'
import { NotificationTableComponent } from './components/notification-table/notification-table.component'
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component'
import { RelatedTransactionsComponent } from './components/related-transactions/related-transactions.component'
import { ExportHistoryComponent } from './components/export-history/export-history.component'
import { ReturnInfoComponent } from './components/return-info/return-info.component'
import { RefundInfoComponent } from './components/refund-info/refund-info.component'
import { NocInfoComponent } from './components/noc-info/noc-info.component'

@NgModule({
    imports: [
        TransactionDetailsModalComponent,
        StatusBadgeComponent,
        TransactionOverviewComponent,
        AuthorizationDetailsComponent,
        NotificationTableComponent,
        TransactionHistoryComponent,
        RelatedTransactionsComponent,
        ExportHistoryComponent,
        ReturnInfoComponent,
        RefundInfoComponent,
        NocInfoComponent,
    ],
    exports: [
        TransactionDetailsModalComponent,
        StatusBadgeComponent,
        TransactionOverviewComponent,
        AuthorizationDetailsComponent,
        NotificationTableComponent,
        TransactionHistoryComponent,
        RelatedTransactionsComponent,
        ExportHistoryComponent,
        ReturnInfoComponent,
        RefundInfoComponent,
        NocInfoComponent,
    ],
})
export class AchTransactionDetailsModule {}
